/**
 * Buying for Business: grouped list, search, variant/SIM/Battery, quantity +/-, selection table, Add/Remove.
 */
(function () {
  function findSection(el) {
    return el && (el.closest('[data-section-id]') || el.closest('.b2b'));
  }

  function getProductsData(section) {
    var script = section && section.querySelector('[data-b2b-products-json]');
    if (!script || !script.textContent) return [];
    try {
      return JSON.parse(script.textContent.trim());
    } catch (e) {
      return [];
    }
  }

  function findVariant(product, option1, option2, option3) {
    if (!product || !product.variants || !product.variants.length) return null;
    var o1 = (option1 || '').toString().trim();
    var o2 = (option2 || '').toString().trim();
    var o3 = (option3 || '').toString().trim();
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if ((v.option1 || '').toString().trim() === o1 &&
          (v.option2 || '').toString().trim() === o2 &&
          (v.option3 || '').toString().trim() === o3) return v;
    }
    return product.variants[0] || null;
  }

  function getVariantTitle(v) {
    if (!v) return '';
    var parts = [v.option1, v.option2, v.option3].filter(Boolean);
    return parts.join(' / ');
  }

  function formatMoney(cents, sectionEl) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(cents);
    var format = sectionEl && sectionEl.getAttribute('data-money-format');
    var currency = (sectionEl && sectionEl.getAttribute('data-currency')) || 'GBP';
    if (format) {
      var amount = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      return format.replace(/\{\{\s*amount\s*\}\}/gi, amount).replace(/\{\{\s*currency\s*\}\}/gi, currency);
    }
    var sym = currency === 'GBP' ? '£' : (currency === 'USD' ? '$' : (currency === 'EUR' ? '€' : ''));
    return sym + (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  function escapeHtml(s) {
    if (s == null) return '';
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function productMatchesSimBattery(product, simSlug, batSlug) {
    var pSim = (product.sim_slug || '').toString();
    var pBat = (product.battery_slug || '').toString();
    var s = (simSlug || '').toString();
    var b = (batSlug || '').toString();
    return (s === '' || pSim === s) && (b === '' || pBat === b);
  }

  function simSlugToLabel(slug) {
    var map = {
      esim: 'eSim',
      'physical-sim': 'Physical Sim',
      wifi: 'Wifi',
      bluetooth: 'Bluetooth',
      cellular: 'Cellular',
      '4g': '4G',
      '5g': '5G'
    };
    return map[slug] || '—';
  }

  function initSection(section) {
    if (!section) return;
    var productsData = getProductsData(section);
    var searchInput = section.querySelector('[data-b2b-search]');
    var listCountEl = section.querySelector('[data-b2b-list-count]');
    var listEl = section.querySelector('[data-b2b-list]');
    var selectionWrap = section.querySelector('[data-b2b-selection-wrap]');
    var selectionTotalEl = section.querySelector('[data-b2b-selection-total]');
    var tbody = section.querySelector('[data-b2b-tbody]');
    var formWrap = section.querySelector('[data-b2b-form]');
    var form = formWrap && formWrap.querySelector('form');
    var bodyInput = section.querySelector('[data-b2b-body]');

    var selection = [];

    // Group products by group_key
    var groups = {};
    productsData.forEach(function (p) {
      var gk = (p.group_key || p.handle || '').toString() || 'none';
      if (!groups[gk]) groups[gk] = [];
      groups[gk].push(p);
    });

    // Sort so groups with available (price > 0) products come first
    var groupKeys = Object.keys(groups).sort(function (a, b) {
      var minPriceA = groups[a].reduce(function (min, p) {
        var v = p.variants && p.variants[0];
        var pr = v && typeof v.price === 'number' ? v.price : Infinity;
        return Math.min(min, pr);
      }, Infinity);
      var minPriceB = groups[b].reduce(function (min, p) {
        var v = p.variants && p.variants[0];
        var pr = v && typeof v.price === 'number' ? v.price : Infinity;
        return Math.min(min, pr);
      }, Infinity);
      var availA = minPriceA > 0 ? 1 : 0;
      var availB = minPriceB > 0 ? 1 : 0;
      if (availA !== availB) return availB - availA;
      return minPriceA - minPriceB;
    });

    function getCurrentProductForGroup(groupProducts, simSlug, batSlug) {
      for (var i = 0; i < groupProducts.length; i++) {
        if (productMatchesSimBattery(groupProducts[i], simSlug, batSlug)) return groupProducts[i];
      }
      return groupProducts[0];
    }

    function findFirstAvailableInGroup(groupProducts) {
      for (var i = 0; i < groupProducts.length; i++) {
        var p = groupProducts[i];
        if (!p.variants || !p.variants.length) continue;
        for (var j = 0; j < p.variants.length; j++) {
          var v = p.variants[j];
          if (typeof v.price === 'number' && v.price > 0) {
            return { product: p, variant: v };
          }
        }
      }
      return { product: groupProducts[0], variant: (groupProducts[0] && groupProducts[0].variants && groupProducts[0].variants[0]) || null };
    }

    function renderList() {
      if (!listEl) return;
      listEl.innerHTML = '';
      groupKeys.forEach(function (gk, groupIndex) {
        var groupProducts = groups[gk];
        var first = groupProducts[0];
        var title = (first && first.title) || '';
        var hasSim = groupProducts.some(function (p) { return (p.sim_slug || p.sim); });
        var hasBattery = groupProducts.some(function (p) { return (p.battery_slug || p.battery); });
        var defaultPick = findFirstAvailableInGroup(groupProducts);
        var currentProduct = defaultPick.product;
        var currentVariant = defaultPick.variant;
        var defaultOpt1 = currentVariant ? (currentVariant.option1 || '') : '';
        var defaultOpt2 = currentVariant ? (currentVariant.option2 || '') : '';
        var defaultOpt3 = currentVariant ? (currentVariant.option3 || '') : '';
        var defaultSim = (currentProduct && (currentProduct.sim_slug || currentProduct.sim)) ? (currentProduct.sim_slug || currentProduct.sim) : 'esim';
        var defaultBattery = (currentProduct && (currentProduct.battery_slug || currentProduct.battery)) ? (currentProduct.battery_slug || currentProduct.battery) : 'standard';
        var imgSrc = (currentVariant && currentVariant.image) || '';

        var li = document.createElement('li');
        li.className = 'b2b__list-item';
        li.setAttribute('data-b2b-row', String(groupIndex));
        li.setAttribute('data-group-key', gk);
        li.setAttribute('data-title', title.toLowerCase());

        var img = document.createElement('img');
        img.className = 'b2b__list-img';
        img.alt = title;
        img.src = imgSrc || 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"%3E%3Crect fill="%23eee" width="100" height="100"/%3E%3C/svg%3E';

        var priceStr = (currentVariant && typeof currentVariant.price === 'number') ? formatMoney(currentVariant.price, section) : '';
        var titleCell = document.createElement('div');
        titleCell.innerHTML = '<p class="b2b__list-title"><a href="' + escapeHtml((currentProduct && currentProduct.url) || (first && first.url) || '#') + '">' + escapeHtml(title) + '</a></p>' + (priceStr ? '<p class="b2b__list-price">' + escapeHtml(priceStr) + '</p>' : '');

        var optsWrap = document.createElement('div');
        optsWrap.className = 'b2b__list-opts';

        // Variant option dropdowns (from current product). Use values from options; if null/empty derive from variants.
        function getOptionValues(product, opt, pos) {
          var vals = (opt.values || []).filter(function (v) { return v != null && String(v).trim() !== ''; });
          if (vals.length > 0) return vals;
          if (!product.variants || !product.variants.length) return [];
          var key = pos === 1 ? 'option1' : (pos === 2 ? 'option2' : 'option3');
          var seen = {};
          return product.variants.map(function (v) { return v[key]; }).filter(function (v) {
            if (v == null || String(v).trim() === '') return false;
            if (seen[v]) return false;
            seen[v] = true;
            return true;
          });
        }
        if (currentProduct && currentProduct.options && currentProduct.options.length) {
          currentProduct.options.forEach(function (opt, optIdx) {
            var pos = opt.position || optIdx + 1;
            var defaultVal = pos === 1 ? defaultOpt1 : (pos === 2 ? defaultOpt2 : defaultOpt3);
            var div = document.createElement('div');
            div.className = 'b2b__list-opt';
            div.innerHTML = '<label>' + escapeHtml(opt.name) + '</label>';
            var sel = document.createElement('select');
            sel.setAttribute('data-b2b-option', String(pos));
            getOptionValues(currentProduct, opt, pos).forEach(function (val) {
              var o = document.createElement('option');
              o.value = val;
              o.textContent = val;
              if (val === defaultVal) o.selected = true;
              sel.appendChild(o);
            });
            div.appendChild(sel);
            optsWrap.appendChild(div);
          });
        }

        if (hasSim) {
          var simDiv = document.createElement('div');
          simDiv.className = 'b2b__list-opt';
          simDiv.innerHTML = '<label>SIM</label>';
          var simSel = document.createElement('select');
          simSel.setAttribute('data-b2b-sim', '');
          var simOpts = [
            { label: 'eSim', slug: 'esim' },
            { label: 'Physical Sim', slug: 'physical-sim' },
            { label: 'Wifi', slug: 'wifi' },
            { label: 'Bluetooth', slug: 'bluetooth' },
            { label: 'Cellular', slug: 'cellular' },
            { label: '4G', slug: '4g' },
            { label: '5G', slug: '5g' }
          ];
          simOpts.forEach(function (o) {
            var opt = document.createElement('option');
            opt.value = o.slug;
            opt.textContent = o.label;
            if (defaultSim === o.slug) opt.selected = true;
            simSel.appendChild(opt);
          });
          simDiv.appendChild(simSel);
          optsWrap.appendChild(simDiv);
        }

        if (hasBattery) {
          var batDiv = document.createElement('div');
          batDiv.className = 'b2b__list-opt';
          batDiv.innerHTML = '<label>Battery</label>';
          var batSel = document.createElement('select');
          batSel.setAttribute('data-b2b-battery', '');
          [{ label: 'Standard', slug: 'standard' }, { label: 'Brand New', slug: 'brand-new' }].forEach(function (o) {
            var opt = document.createElement('option');
            opt.value = o.slug;
            opt.textContent = o.label;
            if (defaultBattery === o.slug) opt.selected = true;
            batSel.appendChild(opt);
          });
          batDiv.appendChild(batSel);
          optsWrap.appendChild(batDiv);
        }

        var qtyActionsRow = document.createElement('div');
        qtyActionsRow.className = 'b2b__list-qty-actions';
        var qtyInner = document.createElement('div');
        qtyInner.className = 'b2b__qty-wrap';
        qtyInner.innerHTML =
          '<button type="button" class="b2b__qty-btn" data-b2b-qty-minus aria-label="Decrease">−</button>' +
          '<input type="number" class="b2b__qty-input" data-b2b-qty min="1" value="1" aria-label="Quantity">' +
          '<button type="button" class="b2b__qty-btn" data-b2b-qty-plus aria-label="Increase">+</button>';
        qtyActionsRow.appendChild(qtyInner);

        var actions = document.createElement('div');
        actions.className = 'b2b__list-actions';
        var addBtn = document.createElement('button');
        addBtn.type = 'button';
        addBtn.className = 'b2b__btn-add';
        addBtn.setAttribute('data-b2b-add', '');
        var isSoldOut = currentVariant && typeof currentVariant.price === 'number' && currentVariant.price === 0;
        addBtn.textContent = isSoldOut ? 'Sold out' : 'Add to selection';
        if (isSoldOut) addBtn.disabled = true;
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'b2b__btn-remove';
        removeBtn.textContent = 'Remove';
        removeBtn.setAttribute('data-b2b-remove', '');
        removeBtn.hidden = true;
        actions.appendChild(addBtn);
        actions.appendChild(removeBtn);
        qtyActionsRow.appendChild(actions);

        li.appendChild(img);
        li.appendChild(titleCell);
        li.appendChild(optsWrap);
        li.appendChild(qtyActionsRow);

        listEl.appendChild(li);

        function getOptValues() {
          var o1 = '', o2 = '', o3 = '';
          li.querySelectorAll('[data-b2b-option]').forEach(function (sel) {
            var pos = parseInt(sel.getAttribute('data-b2b-option'), 10);
            var v = sel.value || '';
            if (pos === 1) o1 = v; else if (pos === 2) o2 = v; else if (pos === 3) o3 = v;
          });
          return { option1: o1, option2: o2, option3: o3 };
        }

        function getSimBattery() {
          var sim = (li.querySelector('[data-b2b-sim]') || {}).value || '';
          var bat = (li.querySelector('[data-b2b-battery]') || {}).value || '';
          return { sim: sim, battery: bat };
        }

        function getQty() {
          var q = li.querySelector('[data-b2b-qty]');
          var n = q ? parseInt(q.value, 10) : 1;
          return isNaN(n) || n < 1 ? 1 : n;
        }

        function updateProductAndVariant() {
          var sb = getSimBattery();
          var product = getCurrentProductForGroup(groupProducts, sb.sim, sb.battery);
          if (!product) return;
          var opts = getOptValues();
          var variant = findVariant(product, opts.option1, opts.option2, opts.option3);
          if (variant && variant.image) img.src = variant.image;
          // Repopulate option dropdowns if product changed
          var optSelects = li.querySelectorAll('[data-b2b-option]');
          if (product.options && product.options.length && optSelects.length === product.options.length) {
            product.options.forEach(function (opt, idx) {
              var sel = optSelects[idx];
              if (!sel) return;
              var cur = sel.value;
              sel.innerHTML = '';
              (opt.values || []).forEach(function (val) {
                var o = document.createElement('option');
                o.value = val;
                o.textContent = val;
                if (val === cur) o.selected = true;
                sel.appendChild(o);
              });
            });
            var v2 = findVariant(product, getOptValues().option1, getOptValues().option2, getOptValues().option3);
            if (v2) {
              if (v2.image) img.src = v2.image;
              updateRowPrice(v2);
              updateSoldOutState(v2);
            }
          } else if (variant) {
            updateSoldOutState(variant);
          }
        }

        function getSelectionLine() {
          var sb = getSimBattery();
          var product = getCurrentProductForGroup(groupProducts, sb.sim, sb.battery);
          if (!product) return null;
          var opts = getOptValues();
          var variant = findVariant(product, opts.option1, opts.option2, opts.option3);
          if (!variant) return null;
          var simLabel = simSlugToLabel(sb.sim);
          var batLabel = sb.battery === 'brand-new' ? 'Brand New' : (sb.battery === 'standard' ? 'Standard' : '—');
          return {
            productId: product.id,
            variantId: variant.id,
            handle: product.handle,
            url: product.url || '',
            title: product.title,
            variantTitle: getVariantTitle(variant),
            sim: simLabel,
            battery: batLabel,
            qty: getQty(),
            price: variant.price,
            groupIndex: groupIndex
          };
        }

        function isInSelection() {
          var line = getSelectionLine();
          if (!line) return false;
          return selection.some(function (s) {
            return s.variantId === line.variantId && s.sim === line.sim && s.battery === line.battery && s.groupIndex === line.groupIndex;
          });
        }

        function updateAddRemoveState() {
          var inSel = isInSelection();
          addBtn.hidden = inSel;
          removeBtn.hidden = !inSel;
          if (!inSel) {
            var line = getSelectionLine();
            if (line) updateSoldOutState({ price: line.price });
          }
        }

        var priceEl = li.querySelector('.b2b__list-price');
        function updateRowPrice(variant) {
          if (priceEl && variant && typeof variant.price === 'number') priceEl.textContent = formatMoney(variant.price, section);
        }
        function updateSoldOutState(variant) {
          var soldOut = variant && typeof variant.price === 'number' && variant.price === 0;
          addBtn.textContent = soldOut ? 'Sold out' : 'Add to selection';
          addBtn.disabled = !!soldOut;
        }
        li.querySelectorAll('[data-b2b-option]').forEach(function (sel) {
          sel.addEventListener('change', function () {
            var sb = getSimBattery();
            var product = getCurrentProductForGroup(groupProducts, sb.sim, sb.battery);
            if (!product) return;
            var opts = getOptValues();
            var variant = findVariant(product, opts.option1, opts.option2, opts.option3);
            if (variant) {
              if (variant.image) img.src = variant.image;
              updateRowPrice(variant);
              updateSoldOutState(variant);
            }
            updateAddRemoveState();
          });
        });

        if (li.querySelector('[data-b2b-sim]')) {
          li.querySelector('[data-b2b-sim]').addEventListener('change', function () {
            updateProductAndVariant();
            var v = findVariant(getCurrentProductForGroup(groupProducts, getSimBattery().sim, getSimBattery().battery), getOptValues().option1, getOptValues().option2, getOptValues().option3);
            if (v) updateRowPrice(v);
            updateAddRemoveState();
          });
        }
        if (li.querySelector('[data-b2b-battery]')) {
          li.querySelector('[data-b2b-battery]').addEventListener('change', function () {
            updateProductAndVariant();
            var v = findVariant(getCurrentProductForGroup(groupProducts, getSimBattery().sim, getSimBattery().battery), getOptValues().option1, getOptValues().option2, getOptValues().option3);
            if (v) updateRowPrice(v);
            updateAddRemoveState();
          });
        }

        var qtyInput = li.querySelector('[data-b2b-qty]');
        if (qtyInput) {
          qtyInput.addEventListener('change', updateAddRemoveState);
          li.querySelector('[data-b2b-qty-minus]').addEventListener('click', function () {
            var n = parseInt(qtyInput.value, 10) || 1;
            if (n > 1) { qtyInput.value = n - 1; updateAddRemoveState(); }
          });
          li.querySelector('[data-b2b-qty-plus]').addEventListener('click', function () {
            var n = parseInt(qtyInput.value, 10) || 1;
            qtyInput.value = n + 1;
            updateAddRemoveState();
          });
        }

        addBtn.addEventListener('click', function () {
          var line = getSelectionLine();
          if (!line) return;
          selection.push(line);
          renderTable();
          updateAddRemoveState();
        });

        removeBtn.addEventListener('click', function () {
          var line = getSelectionLine();
          if (!line) return;
          selection = selection.filter(function (s) {
            return !(s.variantId === line.variantId && s.sim === line.sim && s.battery === line.battery && s.groupIndex === line.groupIndex);
          });
          renderTable();
          updateAddRemoveState();
        });

      });
      updateAllAddRemoveButtons();
      updateListCount();
    }

    function updateListCount(visibleCount) {
      if (!listCountEl) return;
      if (visibleCount != null && visibleCount !== groupKeys.length) {
        listCountEl.textContent = visibleCount + ' of ' + groupKeys.length;
      } else {
        listCountEl.textContent = groupKeys.length;
      }
    }

    function updateTableRowPrice(tr, item) {
      var priceCell = tr.querySelector('.b2b__table-price-cell');
      if (!priceCell) return;
      var unitPrice = typeof item.price === 'number' ? item.price : 0;
      var qty = item.qty || 1;
      var totalCents = unitPrice * qty;
      var totalFormatted = formatMoney(totalCents, section);
      var perItemFormatted = formatMoney(unitPrice, section);
      priceCell.innerHTML = totalFormatted + '<p class="b2b__table-price-per-item">' + escapeHtml(perItemFormatted) + ' per item</p>';
    }

    function updateSelectionTotal() {
      if (!selectionTotalEl) return;
      var totalCents = selection.reduce(function (sum, item) {
        var p = typeof item.price === 'number' ? item.price : 0;
        var q = item.qty || 1;
        return sum + p * q;
      }, 0);
      selectionTotalEl.textContent = selection.length ? 'Total: ' + formatMoney(totalCents, section) : '';
      selectionTotalEl.style.display = selection.length ? '' : 'none';
    }

    function renderTable() {
      if (!tbody) return;
      tbody.innerHTML = '';
      selection.forEach(function (item, idx) {
        var tr = document.createElement('tr');
        tr.setAttribute('data-b2b-row', String(idx));
        var productTd = document.createElement('td');
        if (item.url) {
          var link = document.createElement('a');
          link.href = item.url;
          link.className = 'b2b__table-product-link';
          link.textContent = item.title;
          productTd.appendChild(link);
        } else {
          productTd.textContent = item.title;
        }
        tr.appendChild(productTd);
        tr.appendChild(document.createElement('td')).textContent = item.variantTitle || '—';
        tr.appendChild(document.createElement('td')).textContent = item.sim || '—';
        tr.appendChild(document.createElement('td')).textContent = item.battery || '—';
        var qtyCell = document.createElement('td');
        qtyCell.className = 'b2b__table-qty-cell';
        qtyCell.innerHTML =
          '<div class="b2b__qty-wrap b2b__table-qty-wrap">' +
          '<button type="button" class="b2b__qty-btn" data-b2b-table-qty-minus aria-label="Decrease">−</button>' +
          '<input type="number" class="b2b__qty-input" data-b2b-table-qty min="1" value="' + (item.qty || 1) + '" aria-label="Quantity">' +
          '<button type="button" class="b2b__qty-btn" data-b2b-table-qty-plus aria-label="Increase">+</button>' +
          '</div>';
        tr.appendChild(qtyCell);
        var priceCell = document.createElement('td');
        priceCell.className = 'b2b__table-price-cell';
        tr.appendChild(priceCell);
        updateTableRowPrice(tr, item);
        var removeTd = document.createElement('td');
        removeTd.innerHTML = '<button type="button" class="b2b__table-remove" data-b2b-remove aria-label="Remove">×</button>';
        tr.appendChild(removeTd);
        tbody.appendChild(tr);

        var qtyInput = qtyCell.querySelector('[data-b2b-table-qty]');
        function setQty(n) {
          n = parseInt(n, 10);
          if (isNaN(n) || n < 1) n = 1;
          selection[idx].qty = n;
          qtyInput.value = n;
          updateTableRowPrice(tr, selection[idx]);
          updateSelectionTotal();
        }
        qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });
        qtyCell.querySelector('[data-b2b-table-qty-minus]').addEventListener('click', function () {
          setQty((parseInt(qtyInput.value, 10) || 1) - 1);
        });
        qtyCell.querySelector('[data-b2b-table-qty-plus]').addEventListener('click', function () {
          setQty((parseInt(qtyInput.value, 10) || 1) + 1);
        });
      });
      updateSelectionTotal();
      if (selectionWrap) selectionWrap.setAttribute('data-has-rows', selection.length ? '1' : '0');
    }

    function updateAllAddRemoveButtons() {
      section.querySelectorAll('[data-b2b-row]').forEach(function (li) {
        var addBtn = li.querySelector('[data-b2b-add]');
        var removeBtn = li.querySelector('[data-b2b-remove]');
        if (!addBtn || !removeBtn) return;
        var groupIndex = parseInt(li.getAttribute('data-b2b-row'), 10);
        var gk = li.getAttribute('data-group-key');
        var groupProducts = groups[gk];
        if (!groupProducts) return;
        function getOptValues() {
          var o1 = '', o2 = '', o3 = '';
          li.querySelectorAll('[data-b2b-option]').forEach(function (sel) {
            var pos = parseInt(sel.getAttribute('data-b2b-option'), 10);
            var v = sel.value || '';
            if (pos === 1) o1 = v; else if (pos === 2) o2 = v; else if (pos === 3) o3 = v;
          });
          return { option1: o1, option2: o2, option3: o3 };
        }
        function getSimBattery() {
          var sim = (li.querySelector('[data-b2b-sim]') || {}).value || '';
          var bat = (li.querySelector('[data-b2b-battery]') || {}).value || '';
          return { sim: sim, battery: bat };
        }
        function getSelectionLine() {
          var sb = getSimBattery();
          var product = getCurrentProductForGroup(groupProducts, sb.sim, sb.battery);
          if (!product) return null;
          var opts = getOptValues();
          var variant = findVariant(product, opts.option1, opts.option2, opts.option3);
          if (!variant) return null;
          var simLabel = simSlugToLabel(sb.sim);
          var batLabel = sb.battery === 'brand-new' ? 'Brand New' : (sb.battery === 'standard' ? 'Standard' : '—');
          return { variantId: variant.id, sim: simLabel, battery: batLabel, groupIndex: groupIndex };
        }
        function inSel() {
          var line = getSelectionLine();
          return line && selection.some(function (s) {
            return s.variantId === line.variantId && s.sim === line.sim && s.battery === line.battery && s.groupIndex === line.groupIndex;
          });
        }
        addBtn.hidden = inSel();
        removeBtn.hidden = !inSel();
      });
    }

    renderList();

    if (searchInput && listEl) {
      var noResultsEl = section.querySelector('[data-b2b-no-results]');
      searchInput.addEventListener('input', function () {
        var q = (searchInput.value || '').toLowerCase().trim();
        var visible = 0;
        listEl.querySelectorAll('.b2b__list-item').forEach(function (li) {
          var title = (li.getAttribute('data-title') || '');
          var show = !q || title.indexOf(q) !== -1;
          li.hidden = !show;
          if (show) visible++;
        });
        updateListCount(q ? visible : null);
        if (noResultsEl) noResultsEl.hidden = !(q && visible === 0);
      });
    }

    if (tbody) {
      tbody.addEventListener('click', function (e) {
        var btn = e.target.closest('.b2b__table-remove');
        if (!btn) return;
        var tr = btn.closest('tr');
        if (!tr) return;
        var idx = parseInt(tr.getAttribute('data-b2b-row'), 10);
        if (isNaN(idx) || idx < 0 || idx >= selection.length) return;
        selection.splice(idx, 1);
        renderTable();
        updateAllAddRemoveButtons();
      });
    }

    if (form && bodyInput) {
      form.addEventListener('submit', function () {
        var commentEl = form.querySelector('[name="contact[comment]"]');
        var comment = commentEl ? commentEl.value : '';
        var docTypeEl = section.querySelector('[data-b2b-doc-type]');
        var docType = docTypeEl && docTypeEl.value ? docTypeEl.value.trim() : '';
        var docUrlEl = section.querySelector('[data-b2b-doc-url]');
        var docUrl = docUrlEl && docUrlEl.value ? docUrlEl.value.trim() : '';
        var extra = [];
        if (docType) extra.push('Doc Type: ' + docType);
        if (docUrl) extra.push('Document (verify your business): ' + docUrl);
        if (comment) extra.push('Comment: ' + comment);
        bodyInput.value = buildBodyText() + (extra.length ? '\n\n' + extra.join('\n\n') : '');
      });
    }

    function buildBodyText() {
      var lines = [];
      lines.push('--- Business product selection ---');
      var totalCents = 0;
      selection.forEach(function (item) {
        var price = typeof item.price === 'number' ? item.price : 0;
        var qty = item.qty || 1;
        totalCents += price * qty;
        lines.push(item.title + ' | ' + (item.variantTitle || '') + ' | SIM: ' + (item.sim || '—') + ' | Battery: ' + (item.battery || '—') + ' | Qty: ' + item.qty + ' | Price: ' + (price ? formatMoney(price, section) : '—'));
      });
      lines.push('---');
      if (selection.length) lines.push('Total: ' + formatMoney(totalCents, section));
      return lines.join('\n');
    }
  }

  function init() {
    document.querySelectorAll('.b2b').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.b2b') || e.target;
    if (section.classList && section.classList.contains('b2b')) initSection(section);
  });
})();
